import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';
import UKFlag from '../../images/uk-flag.webp';
import ThaiFlag from '../../images/thai-flag.webp';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng).then(() => {
      localStorage.setItem('i18nextLng', lng);
      window.location.reload();
    });
  };

  const buttonStyle = {
    background: 'none',
    border: 'none',
    padding: '2px',
    margin: '0',
    width: '28px',
    height: '28px'
  };

  const imgStyle = {
    width: '24px',
    height: '24px',
    display: 'block'
  };

  return (
    <div style={{ display: 'flex', gap: '2px' }}>
      <button onClick={() => changeLanguage('en')} style={buttonStyle}>
        <img src={UKFlag} alt="English" style={imgStyle} />
      </button>
      <button onClick={() => changeLanguage('th')} style={buttonStyle}>
        <img src={ThaiFlag} alt="Thai" style={imgStyle} />
      </button>
    </div>
  );
};

export default LanguageSelector;